<template>
    <section class="customerPoolRule">
		<Nav title="分单规则" />
        <section class="card_list">
            <div class="card">
                <div class="item">
                    <div class="label"><p>机构分单规则</p></div>
                    <div class="info flex">
                        <div class="bb-bar-button-group">
                            <div :class="!orgInfo.customerPoolRule? 'active':''" @click="changeOrgCustomerPoolRule(0)">自动分配</div>
                            <div :class="orgInfo.customerPoolRule? 'active':''" @click="changeOrgCustomerPoolRule(1)">手动分配</div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="card" v-if="teamList.length">
                <div class="head">
                    <h3>团队分单规则</h3>
                </div>
                <div class="item" v-for="team in teamList" :key="team.id">
                    <div class="label"><p>{{team.teamName}}</p></div>
                    <div class="info flex">
                        <div class="bb-bar-button-group">
                            <div :class="!team.customerPoolRule? 'active':''" @click="changeTeamCustomerPoolRule(team,0)">自动分配</div>
                            <div :class="team.customerPoolRule? 'active':''" @click="changeTeamCustomerPoolRule(team,1)">手动分配</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="button_area">
                <van-button round block type="primary" to="/setting" native-type="submit">返回</van-button>                
            </div>
        </section>
	</section>
</template>

<script>
import Nav from "components/Nav"
import { Toast } from 'vant';

import settingServer from "api/setting";
import teamServer from "api/team";

export default {
    name: "customerPoolRule",
	components: {
		Nav,
	},
    data() {
        return {
            orgInfo: {},
            teamList: [],
            accountType: '',
		};
    },
    created() {
        this.getInfo();
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},	
    methods: {
        getInfo() {
            this.getOrgInfo()
            this.getTeamInfo()
         },

        getOrgInfo() {
            settingServer.getOrgInfo().then((res) => {
                this.orgInfo = res.data
            })
        },

        getTeamInfo() {
            teamServer.getTeamPageList({"pageNum": 1, "pageSize": 1000}).then((res) => {
                if (res.data.total) {
                    this.teamList = res.data.list
                } else {
                    this.TeamList = []
                }
            })
        },

        changeOrgCustomerPoolRule(rule) {
            if (rule == this.orgInfo.customerPoolRule) return

            if (this.orgInfo.subscriptionVersion == 1) return Toast('入门版无手动分配功能')

            settingServer.changeCustomerPoolRule({"orgMatchRule": rule}).then((res) => {
                this.getOrgInfo()
                Toast('修改机构分单规则成功')
            })            
        },

        changeTeamCustomerPoolRule(team, rule) {
            if (rule == team.customerPoolRule) return

            settingServer.changeCustomerPoolRule({"teamId": team.id, "teamMatchRule": rule}).then((res) => {
                this.getTeamInfo()
                Toast('修改团队分单规则成功')
            })            
        },
        
    },
};
</script>

<style lang="scss">
	.customerPoolRule {
		padding-top: 46px;
		padding-bottom: 100px;

        .head {
            h3 {
                padding: 12px 20px 6px 30px;
                font-size: 14px;
                border-bottom: 1px solid #E9F0F8;
            }
        }

        .card {
            margin-bottom: 22px;
            background-color: #FDFDFD;
            border-radius: 24px;

            .item {
                margin-left: 30px;
                padding: 20px 30px 20px 0;
                border-bottom: 1px solid #E9F0F8;
                display: flex;
                justify-content: space-between;

                .label p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #4D5B80;
                }

                .info p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #000;
                }

                .info.flex {
                    display: flex;
                    align-items: center;

                    p {
                        margin-right: 4px;
                    }
                }
            }

            .item:last-child {
                border-bottom: 0;
            }
        }

        .button_area {
            margin: 30px;
        }

        .bb-bar-button-group {
            display: flex;

            >div {
                font-size: 11px;
                line-height: 1;
                padding: 4px 8px;
                border: 1px solid #055ce8;
            }

            >div:first-child {
                border-right: 0;
                border-radius: 4px 0 0 4px;
            }

            >div:last-child {
                border-radius: 0 4px 4px 0;
            }

            >div.active {
                background-color: #055ce8;
                color: #fefefe;
            }
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/setting/customerPoolRule/CustomerPoolRule.vue